import { render, staticRenderFns } from "./BandejaEspecialidadComponente.vue?vue&type=template&id=3f510702"
import script from "./BandejaEspecialidadComponente.vue?vue&type=script&lang=js"
export * from "./BandejaEspecialidadComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports